module.exports = __webpack_public_path__ + "img/screen-2.bb09647c.png";